//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import CRUDGenerico from '../../../../../shared-components/generico/CRUDGenerico';
import RegisterForm from '../../../../../shared-components/generico/RegisterForm';
import mdAutocomplete from '../../../../../shared-components/autocomplete/mdAutocomplete';
import InputMoney from '../../../../../shared-components/InputMoneyOld';
import { copyObject } from '../../../../../common/functions/helpers';
import ModalVoltar from '../../../../../shared-components/ModalVoltar';

export default {
  name: 'AjusteVerbaForm',
  extends: CRUDGenerico,
  props: {
    somenteLeitura: Boolean,
    novo: Boolean,
    fluxo: Boolean,
  },
  data() {
    return {
      fetchOrcamentoFunction: this.$api.orcamento(this.$resource).listarAprovados,
      fetchLinhaFunction: this.$api.linhasInvestimento(this.$resource).buscarPorOrcamento,
      desdobramentoResource: this.$api.desdobramento(this.$resource),
      workflowAjusteVerbaResources: this.$api.workflowAjusteVerba(this.$resource),
      ajusteVerbaResource: this.$api.ajusteVerba(this.$resource),
      orcamentoResources: this.$api.orcamento(this.$resource),
      tipo: 'ADENDO',
      justificativaReprovacao: '',
      ajuste: {
        tipo: 'ADENDO',
        idOrcamento: null,
        descricaoOrcamento: '',
        idLinhaInvestimento: null,
        descricaoLinha: '',
        idDesdobramento: null,
        competencia: '',
        idRepresentante: null,
        representante: '',
        valor: 0,
        vlrPlanejado: 0,
        vlrDisponivel: 0,
        justificativa: '',
      },
      justificarAjuste: {
        observacao: '',
        obrigatorio: false,
      },
      fluxoAjuste: {},
      podeAprovar: false,
      podeReprovar: false,
      disableButton: false,
      disableLinha: true,
      disableDesdobramento: true,
      disableRepresentante: true,
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() {},
      },
    };
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'ORC_AJUSTE' || el === 'DASH_OPER_ORC').length;
    },
    canPost() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'ORC_AJUSTE').length;
    },
    canSearch() {
      return this.canAccessPage;
    },
  },
  methods: {
    requestPermiteAprovar() {
      this.podeAprovar = false;
      this.podeReprovar = false;
      if (this.fluxo && this.fluxoAjuste.statusFluxo === 'AGUARDANDO_APROVACAO') {
        const idAjuste = this.$route.params.id;
        this.workflowAjusteVerbaResources.aprovador({ idAjuste })
          .then((response) => {
            if (response.data.usuarioHabilitado) {
              this.podeAprovar = true;
              this.podeReprovar = true;
            }
          })
          .catch((err) => {
            this.$error(this, err);
          });
      }
    },
    openDialogJustificativaReprovar() {
      this.justificarAjuste.observacao = '';
      this.justificarAjuste.obrigatorio = true;
      this.justificarAjuste.action = this.requestReprovar;

      this.openDialog('justificarDialog');
    },
    openDialogReprovar(ref, from) {
      // this.motivo = '';
      const content = this.$t('message.deseja_reprovar_ajuste_verba');
      this.setDialogContent(content, this.openDialogJustificativaReprovar,
        from || this.dialog.from);
      this.openDialog(ref || this.dialog.ref);
    },
    openDialogAprovar(ref, from) {
      // this.motivo = '';
      if (!this.validarValor()) {
        return;
      }
      const content = this.$t('message.deseja_aprovar_ajuste_verba');
      this.setDialogContent(content, this.requestAprovar, from || this.dialog.from);
      this.openDialog(ref || this.dialog.ref);
    },
    requestAprovar() {
      const idAjuste = this.ajuste.id;
      this.workflowAjusteVerbaResources.aprovar({ idAjuste }, {})
        .then(() => {
          this.voltar();
          this.$toast.create(this.$t('message.ajuste_verba_aprovado'), 'snack', 3E3);
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    requestReprovar() {
      const payload = {};
      payload.observacao = this.justificarAjuste.observacao;
      const idAjuste = this.ajuste.id;
      this.workflowAjusteVerbaResources.reprovar({ idAjuste }, payload)
        .then(() => {
          this.voltar();
          this.$toast.create(this.$t('message.ajuste_verba_reprovado'), 'snack', 3E3);
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    setOrcamento(hit) {
      if (!hit.id) {
        this.limparOrcamento();
        return;
      }
      this.disableLinha = false;
      this.ajuste.idOrcamento = hit.id;
      this.ajuste.descricaoOrcamento = hit.descricao;
      this.ajuste.descricaoLinha = '';
      this.limparLinha();
    },
    setLinha(hit) {
      if (!hit.id) {
        this.limparLinha();
        return;
      }
      this.disableDesdobramento = false;
      this.ajuste.idLinhaInvestimento = hit.id;
      this.ajuste.descricaoLinha = hit.descricao ? hit.descricao.trim() : '';
      this.ajuste.competencia = '';
      this.limparDesdobramento();
    },
    setDesdobramento(hit) {
      if (!hit.id) {
        this.limparDesdobramento();
        return;
      }
      this.disableRepresentante = false;
      this.ajuste.idDesdobramento = hit.id;
      this.ajuste.competencia = hit.anoMes;
      this.ajuste.representante = '';
      this.limparRepresentante();
    },
    setRepresentante(hit) {
      if (!hit.idRepresentante) {
        this.limparRepresentante();
        return;
      }
      this.ajuste.idRepresentante = hit.idRepresentante;
      this.ajuste.idControladorDestino = hit.idControladorTrade;
      this.ajuste.representante = hit.nome;
      this.buscarValoresRepresentante();
    },
    buscarLinha(row) {
      row.codigo = this.ajuste.idOrcamento;
      return this.fetchLinhaFunction(row);
    },
    buscarDesdobramento(row) {
      return this.desdobramentoResource.buscarVigentesPorLinhaInvestimento(
        { codigo: this.ajuste.idLinhaInvestimento, anoMes: row.anoMes });
    },
    buscarRepresentante(row) {
      row.codigo = this.ajuste.idDesdobramento;
      row.indAtivo = true;

      return this.desdobramentoResource.buscarRepresentantes(row);
    },
    buscarValores() {
      return this.desdobramentoResource.buscarPlanejadoDisponivel(
        { codigo: this.ajuste.idDesdobramento })
        .then(this.preencherValores)
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscarValoresRepresentante() {
      return this.desdobramentoResource.buscarPlanejadoDisponivelRepresentante(
        { codigo: this.ajuste.idDesdobramento, idRepresentante: this.ajuste.idRepresentante })
        .then(this.preencherValores)
        .catch((err) => {
          this.$error(this, err);
        });
    },
    preencherValores(response) {
      this.ajuste.vlrPlanejado = response.data.vlrPlanejado;
      this.ajuste.vlrDisponivel = response.data.vlrDisponivel;
    },
    limparOrcamento() {
      this.ajuste.idOrcamento = null;
      this.ajuste.descricaoLinha = '';
      this.disableLinha = true;
      this.limparLinha();
    },
    limparLinha() {
      this.ajuste.idLinhaInvestimento = null;
      this.ajuste.competencia = '';
      this.disableDesdobramento = true;
      this.limparDesdobramento();
    },
    limparDesdobramento() {
      this.disableRepresentante = true;
      this.ajuste.idDesdobramento = null;
      this.ajuste.representante = '';
      this.ajuste.vlrPlanejado = 0;
      this.ajuste.vlrDisponivel = 0;
      this.ajuste.idRepresentante = null;
    },
    limparRepresentante() {
      this.ajuste.idRepresentante = null;
      this.ajuste.idControladorDestino = null;
      if (this.ajuste.idDesdobramento) this.buscarValores();
    },
    validarValor() {
      if (this.ajuste.valor <= 0) {
        this.$toast.create(this.$t('errors.valor.maior_zero'), 'snack', 3E3);
        return false;
      }
      if (this.ajuste.tipo === 'REDUCAO' && this.ajuste.valor > this.ajuste.vlrDisponivel) {
        this.$toast.create(this.$t('errors.valor.disponivel.excedido'), 'snack', 3E3);
        return false;
      }
      return true;
    },
    openCancelDialog() {
      this.$refs.voltarDialog.open();
    },
    cancel() {
      this.voltar();
    },
    openSaveDialog(ref, from) {
      if (!this.canPost) {
        return;
      }
      this.$validator.validateAll()
        .then((isValid) => {
          if (!this.validarValor() || !isValid) {
            return;
          }
          this.setDialogContent(this.$t('message.salvar_novo_ajuste_verba'), this.save, from || this.dialog.from);
          this.openDialog(ref || this.dialog.ref);
        });
    },
    openSaveDialogVoltar() {
      // Vem para este metodo para não mostrar modal de salvar novamente.
      if (!this.canPost) {
        return;
      }
      this.$validator.validateAll()
        .then((isValid) => {
          if (!this.validarValor() || !isValid) {
            return;
          }
          this.save();
        });
    },
    save() {
      if (!this.canPost) {
        return;
      }
      const objeto = copyObject(this.ajuste);
      objeto.valor = this.ajuste.valor;
      this.ajusteVerbaResource.gravar(objeto)
        .then(this.tratarSalvoSucesso)
        .catch((err) => {
          if (err.status !== 500) {
            this.$error(this.$t('message.ajuste_verba_erro_azion'));
          }
          this.$error(this, err);
        });
    },
    tratarSalvoSucesso(response) {
      this.$router.push({ name: 'orcamento' });

      if (response.data.status === 'APROVADO') {
        this.$toast.create(this.$t('message.ajuste_verba_finalizado'), 'snack', 3E3);
      } else {
        this.$toast.create(this.$t('message.ajuste_verba_enviado_aprovacao'), 'snack', 3E3);
      }
    },
    voltar() {
      if (this.fluxo) {
        this.$router.push({ name: 'dashboard' });
      } else {
        this.$router.push({ name: 'orcamento' });
      }
    },
    closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
    setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    async carregarAjuste(orcamento) {
      if (orcamento.length === 1) {
        this.ajuste = orcamento[0] || {};
        this.disableDesdobramento = false;
      } else if (orcamento.length > 1 && typeof orcamento !== 'number') {
        this.disableDesdobramento = false;
        this.ajuste.descricaoOrcamento = orcamento[0].descricaoOrcamento;
        this.ajuste.idOrcamento = orcamento[0].idOrcamento;
        this.carregarLinha(orcamento);
      } else if (typeof orcamento === 'number') {
        const res = await this.ajusteVerbaResource.obter({ id: orcamento });
        this.ajuste = res.body;
        this.carregarLinha([this.ajuste]);
      }
    },
    carregarLinha(ajuste) {
      const element = ajuste[0].idLinhaInvestimento;
      if (ajuste.filter(el => el.idLinhaInvestimento !== element).length) {
        this.disableLinha = false;
        this.ajuste.descricaoLinha = '';
        this.limparLinha();
      } else {
        this.ajuste.idLinhaInvestimento = ajuste[0].idLinhaInvestimento;
        this.ajuste.descricaoLinha = ajuste[0].descricaoLinha;
      }
    },
    carregarFluxo() {
      if (this.fluxo || this.ajuste.status === 'REPROVADO') {
        this.fluxoAjuste.usuarioSolicitante = {};
        const idAjuste = this.$route.params.id;
        this.workflowAjusteVerbaResources.status({ idAjuste }, { idAjuste })
          .then((response) => {
            this.fluxoAjuste = response.data;
            this.preencherJustificativaReprovacao();
            this.requestPermiteAprovar();
          })
          .catch((err) => {
            this.$error(this, err);
          });
      }
    },
    preencherJustificativaReprovacao() {
      if (this.fluxoAjuste && this.fluxoAjuste.passoAtual) {
        this.justificativaReprovacao = this.fluxoAjuste.passoAtual.observacao;
      }
    },
    carregarValores() {
      if (this.ajuste.idRepresentante) {
        this.buscarValoresRepresentante();
        return;
      }
      this.buscarValores();
    },
  },
  beforeMount() {
    if (this.$route.params.ajuste && this.$route.params.ajuste.length) {
      this.carregarAjuste(this.$route.params.ajuste);
    }
    if (this.$route.params.id) {
      this.carregarAjuste(parseInt(this.$route.params.id, 10));
    }
  },
  components: {
    RegisterForm,
    mdAutocomplete,
    InputMoney,
    ModalVoltar,
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/orcamento/ajuste-verba/AjusteVerbaForm.vue?vue&type=script&lang=js&